import React, { useCallback } from 'react';
import { Box, Typography } from '@mui/material';

const CodeEditor = ({
  value = '',
  onChange,
  language = 'python',
  placeholder = '',
  minRows = 10,
  readOnly = false,
  label,
}) => {
  const handleKeyDown = useCallback((e) => {
    if (e.key === 'Tab') {
      e.preventDefault();
      const el = e.target;
      const start = el.selectionStart;
      const end = el.selectionEnd;
      const indent = '    ';
      const next = value.substring(0, start) + indent + value.substring(end);
      onChange(next);
      requestAnimationFrame(() => {
        el.selectionStart = el.selectionEnd = start + indent.length;
      });
    }
  }, [value, onChange]);

  return (
    <Box>
      {label && (
        <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mb: 0.5, fontWeight: 600, textTransform: 'uppercase', letterSpacing: 0.8 }}>
          {label} — {language.toUpperCase()}
        </Typography>
      )}
      <Box
        component="textarea"
        value={value}
        onChange={readOnly ? undefined : (e) => onChange(e.target.value)}
        onKeyDown={readOnly ? undefined : handleKeyDown}
        readOnly={readOnly}
        placeholder={placeholder}
        rows={minRows}
        spellCheck={false}
        sx={{
          display: 'block',
          width: '100%',
          boxSizing: 'border-box',
          bgcolor: '#1e1e1e',
          color: '#d4d4d4',
          fontFamily: '"Source Code Pro", "Fira Code", "Courier New", monospace',
          fontSize: '0.85rem',
          lineHeight: 1.6,
          p: 2,
          border: '1px solid',
          borderColor: 'divider',
          borderRadius: 1,
          resize: 'vertical',
          outline: 'none',
          transition: 'border-color 0.15s',
          '&:focus': { borderColor: 'primary.main' },
          '&::placeholder': { color: '#666' },
          '&:read-only': { opacity: 0.8, cursor: 'default' },
        }}
      />
    </Box>
  );
};

export default CodeEditor;
